export const getLanguageCodeAbbreviation = (languageCode: string) => languageCode.replace(/-[a-z]{2}/i, '');
